// extracted by mini-css-extract-plugin
export default {"page":"VisibilityPreference_page__mojJZ","pathwaysImg":"VisibilityPreference_pathwaysImg__vFZlh"};